import { httpClient } from './httpClient';

export const fetchPlanslist = async () => {
  const response = await httpClient.get('/plans/list');
  return response.data;
};

export const fetchPlanscreate = async (payload) => {
  const response = await httpClient.post('/plans/create', payload);
  return response.data;
};

export const getCompanyPlans = async (companyId) => {
  const response = await httpClient.get(`/plans/${companyId}`);
  return response.data;
};
